export default __webpack_public_path__ + "static/media/upActive.8a3303cf.svg";